<template>
	<pins-item :hasAction="true" @click="onAction_ClickHandler">
		<div class="pins-item-patient">
			<div class="pins-item-patient__g1">
				<avatar :size="50" :src="patient.picture" :name="patient.name" />
			</div>
			<div class="pins-item-patient__g2">
				<span class="sk-value">{{ patient.name }}</span>
				<span class="sk-sub-value">{{ patient.profile.address }}</span>
			</div>
		</div>
		<template v-slot:footer>
			<pins-item-footer :title="$t('Heart rate')" :value="lastHeartRate" />
			<pins-item-footer :title="$t('Alerts')" :value="countAlerts"/>
			<pins-item-footer :title="$t('Last Sync')" :value="lastSync" />
		</template>
	</pins-item>
</template>

<script>
import Datetime from '@/utils/Datetime'
import moment from 'moment'
import { mapGetters } from 'vuex'
import PinsItem from '@/modules/pins/PinsItem'
import PinsItemFooter from '@/modules/pins/PinsItemFooter'
import Avatar from '@/modules/ui/Avatar'
export default {
	name: 'pins-item-patient',
	components: {
		PinsItem,
		PinsItemFooter,
		Avatar
	},
	props: {
		patient: {
			type: Object,
			required: true
		}
	},
	computed: {
		lastHeartRate() {
			const list = this.getPatientByType(this.patient, this.type, Datetime.toKey(moment()))
			if (list.length === 0)
				return '-'
			const reading = list.sort((a1, a2) => a1.key - a2.key)[0]
			return reading.base.last
		},
		countAlerts() {
			return this.getAlerts(this.patient).length
		},
		lastSync() {
			const lastReadingTime = this.getLastSync(this.patient)
			if (!lastReadingTime) {
				return '-'
			}
			return moment(lastReadingTime).fromNow()
		},
		...mapGetters({
			currentUser: 'CURRENT_USER',
			getPatientByType: 'PATIENTS_READINGS_BY_TYPE',
			getAlerts: 'PATIENTS_ALERTS',
			getLastSync: 'PATIENTS_READINGS_LAST_SYNC'
		})
	},
	methods: {
		onAction_ClickHandler() {
			this.$router.push({
				name: 'WatchDashboard',
				params: {
					user_uid: this.currentUser.uid,
					watch_id: this.patient.id
				}
			})
		}
	}
}
</script>

<style scoped>
.pins-item-patient {
	display: flex;
}
.pins-item-patient__g1 {
	padding: 20px;
}
.pins-item-patient__g2 {
	padding: 20px 20px 20px 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/modules/pins/PinsItemPatient.vue